import React from 'react'

import type { MatchCriteriaKey as MatchCriteriaKeyProps } from '@/api/types/matchCriteria'
import { ReactComponent as ArrowIcon } from '@/assets/svgs/arrow-line-only.svg'
import { IconGenerator } from '@/UIkit/IconGenerator'

import { Txt } from './PropertyMatch'
import * as S from './styles'

export const PropertyMatchKey = ({
  labelFull,
  labelShort,
  status,
  type,
  isHighlight = true,
}: MatchCriteriaKeyProps & {
  isHighlight?: boolean
}) => (
  <S.KeyTag key={type} isHighlight={isHighlight} status={status} $radius="lg">
    <S.KeyIconWrapper>
      <IconGenerator
        iconComponent={ArrowIcon}
        size={14}
        rotationDegrees={status === 'best' ? 90 : -90}
        viewBox="0 0 24 24"
      />
    </S.KeyIconWrapper>
    <Txt $fs="14" $lineHeight={1.2}>
      {isHighlight ? labelShort : labelFull}
    </Txt>
  </S.KeyTag>
)
